import en from './en.js'
import py from './py.js'
import fy from './fy.js'
import sy from './sy.js'
export default {
  en,
  py,
  fy,
  sy
}
